/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography2, VisuallyHidden, breakpoints, typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/front-page';

const styles = {
  salaryInfo: css`
    ${breakpoints.down('xs')} {
      ${typography2.bodySecondary};
      color: var(--cds-color-neutral-primary-weak);

      strong {
        color: var(--cds-color-neutral-primary-weak);
        font-weight: 400;
      }
    }
  `,
};

type SalaryInfoProps = {
  medianSalary: number;
  currencyCode: string;
  testId?: string;
};

const SalaryInfo = ({ medianSalary, currencyCode, testId = 'median-salary' }: SalaryInfoProps) => {
  const salary = (
    <FormattedNumber
      value={medianSalary}
      // eslint-disable-next-line react/style-prop-object
      style="currency"
      currency={currencyCode}
      maximumFractionDigits={0}
      minimumFractionDigits={0}
    />
  );

  return (
    <Typography2 data-testid={testId} variant="bodySecondary" color="supportText" component="p" css={styles.salaryInfo}>
      {/* Screen reader only */}
      <VisuallyHidden component="span">
        <FormattedMessage message={_t('This role has a {medianSalary} median salary ¹.')} medianSalary={salary} />
      </VisuallyHidden>
      {/* Display purposes only, not announced by screen reader (handled above) */}
      <span aria-hidden="true">
        <FormattedMessage message={_t('{medianSalary} median salary ¹')} medianSalary={<strong>{salary}</strong>} />
      </span>
    </Typography2>
  );
};

export default SalaryInfo;
